"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableCell = exports.sortingDirections = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TableCellContext = require("./TableCellContext");

var styles = {
  "TableCell": "TableCell__TableCell___Wou8a",
  "TableCell--head": "TableCell__TableCell--head___1HhvZ",
  "TableCell--head__sorting": "TableCell__TableCell--head__sorting____Jc1k"
};
var sortingDirections = {
  asc: 'asc',
  desc: 'desc'
};
exports.sortingDirections = sortingDirections;
var defaultProps = {
  align: 'left',
  sorting: false,
  testId: 'cf-ui-table-cell'
};

var TableCell = function TableCell(props) {
  var className = props.className,
      children = props.children,
      sorting = props.sorting,
      align = props.align,
      testId = props.testId,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "children", "sorting", "align", "testId"]);
  return /*#__PURE__*/_react["default"].createElement(_TableCellContext.TableCellContext.Consumer, null, function (_ref) {
    var _cn;

    var context = _ref.name,
        element = _ref.element,
        offsetTop = _ref.offsetTop;
    var Element = element;
    return /*#__PURE__*/_react["default"].createElement(Element, (0, _extends2["default"])({
      className: (0, _classnames["default"])(styles['TableCell'], className, (_cn = {}, (0, _defineProperty2["default"])(_cn, styles['TableCell--head'], context === 'head'), (0, _defineProperty2["default"])(_cn, styles['TableCell--head__sorting'], sorting), _cn)),
      style: {
        top: offsetTop
      },
      align: align,
      "data-test-id": testId
    }, otherProps), children);
  });
};

exports.TableCell = TableCell;
TableCell.defaultProps = defaultProps;
var _default = TableCell;
exports["default"] = _default;